export default __webpack_public_path__ + "static/media/food-beverage.96ec42f9.svg";